import React from "react";
import { ArrowBigUpDash } from "lucide-react";

import { MB_FILE_SIZE } from "./hooks/useFileValidation";

export const FileDropZone = () => {
  return (
    <div className="flex flex-col gap-4 w-full text-center">
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-center">
          <ArrowBigUpDash className="text-[#5A5E6E] fill-[#5A5E6E]" size={32} />
        </div>
        <div className="font-['Inter'] font-normal text-sm leading-[180%] tracking-normal text-[#222222]">
          Drag and drop the resume here
        </div>
        <div className="font-['Inter'] font-normal text-sm leading-[180%] tracking-normal text-[#5A5E6E]">
          or click to select a file
        </div>
      </div>

      <div className="font-['Inter'] font-normal text-xs leading-[180%] tracking-[0%] text-[#5A5E6E]">
        Supports PDF, DOC, DOCS (max {MB_FILE_SIZE}mb)
      </div>
    </div>
  );
};
